import React from "react";
import { MainContainer, TitleContainer } from "./styles";
import { SectionItemProps } from "./types";
import Typography from "../../../../../../../../../../components/Typography";

const SectionItem: React.FC<SectionItemProps> = ({
  description,
  title,
}): JSX.Element => {
  return (
    <MainContainer>
      <TitleContainer>
        <Typography
          text={title}
          size={"medium"}
          color="Bg300"
          weight={500}
        />
      </TitleContainer>
      <Typography
        text={description}
        size={"small"}
        color={"Bg300"}
        weight={200}
      />
    </MainContainer>
  );
};

export default SectionItem;
